import React, { useEffect } from 'react';
import { useLocalStorage } from 'react-use';
import { useI18n } from '@whizz/react-i18n';
import type { OptionTypeBase } from 'react-select';
import type { ButtonContentAlignType } from '../../components/button/types';
import type { SizeType } from '../../util/types';
import { Dropdown } from '../../components';
import { mapClassesForSelector } from '../../mapper/classesMapper';
import type { NewClassGetItem } from '@whizz/api-model/src/endpoints/NewClass';

export const useSaveClass = (teacherUsername: string): [{
  label: string;
  value: number;
} | null | undefined, React.Dispatch<React.SetStateAction<{
  label: string;
  value: number;
} | null | undefined>>] => {

  const [ value, setValue ] = useLocalStorage<{ label: string, value: number } | null>(`last_session_class_${teacherUsername}`, null);
  return [ value, setValue ];
};

export const useClassSelector = (teacherUsername: string, teacherClasses: NewClassGetItem[], align: ButtonContentAlignType = 'center', size: SizeType = 'md'): (OptionTypeBase | null)[] => {
  const { translate } = useI18n();
  const [ value, setValue ] = useSaveClass(teacherUsername);
  const classesLabelValue = mapClassesForSelector(teacherClasses);

  useEffect(() => {
    if (null != value || 1 !== classesLabelValue.length) {
      return;
    }

    setValue(classesLabelValue[0]);
  }, [ teacherClasses ]);

  const selector = (
    <div className={'w-full'}>
      <Dropdown
        id={'academic_year_selector'}
        className={'mx-auto'}
        size={size}
        align={align}
        label={'Academic year'}
        hideLabel
        buttonPlaceholder={translate('components.SELECTORS.PLACEHOLDERS.CLASS_GROUP')}
        searchNoOptions={translate('components.SELECTORS.NO_OPTIONS.CLASS_GROUP')}
        options={classesLabelValue}
        value={value}
        handleChange={(option: { label: string, value: number }) => {
          setValue(option);
        }}
      />
    </div>
  );

  return [ selector, value ?? null ];
};
